module.exports = __webpack_public_path__ + "static/img/news_32.d9aca52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_32.png
// module id = ABpM
// module chunks = 2